<template>
  <div class="vx-row">
    <div class="vx-col md:w-1/2 w-full mb-base">
      <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;" label-placeholder="Title:"
                  v-model="onboardingName"/>
    </div>
    <div class="vx-col md:w-1/2 w-full mb-base">
      <vs-input class="vx-col w-1/1 lg:w-1/1" style="width:100%;"
                label-placeholder="Description"
                 v-model="onboardingDescription"/>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vs-button @click="SaveChanges(onboardingName,onboardingDescription)" class="ml-5">Save</vs-button>
      </div>
    </div>
  </div>
  
 </template>

<script>
  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  export default {
    data() {
      return {
        fontFace: 'Default',
        domains: ['example1.com', 'example2.com', 'example3.com'], // Example data for the domains list
        isModalOpen: false,
        selectedDomain: '',
        onboardingName: "",
        onboardingDescription: "",

        registeredUrls: [], // Example data for registered URLs
        newUrl: '',
      };
    },
    props: ["onboarding"],
    methods: {
      SaveChanges(onboardingName, onboardingDescription) {
        var instance =  this;
        const query = `
    mutation UpdateOnboarding($onboarding: OnboardingInput!) {
      updateMainFields(
        entity: $onboarding
      ) {
        id,
        name
        description
        rawContent
      }
    }
  `;
        this.onboarding.name = onboardingName
        this.onboarding.description = onboardingDescription
        const variables = {
          onboarding: instance.onboarding
        };
        

        const req = {
          query,
          variables
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            alert("You're good to go.");
          }
          else if (response && response.data && response.data.errors) {
            alert('There were some errors saving :(');
          }
        });
      },
    }
  };
</script>
